<template>
  <!-- 法律知识 -->
  <div id="laws">

    <section><lawsmenu /></section>

    <section><lawsjxflzs /></section>

    <section><lawsifynew /></section>

    <section><lawsjxlmtj /></section>


  </div>
  
</template>

<script>


import lawsmenu from "./child/lawsmenu";//法律知识菜单列表
import lawsjxflzs from "./child/lawsjxflzs";//精选法律知识
import lawsifynew from "./child/lawsifynew";//精选分类
import lawsjxlmtj from "./child/lawsjxlmtj";//精选栏目推荐

export default {
  name: "laws",
  components: {

    // 页面内
    lawsmenu,
    lawsjxflzs,
    lawsifynew,
    lawsjxlmtj,

  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#laws {
  background-color: #fff;
}
</style>
